import {createAction} from '@reduxjs/toolkit'
import {ModalType} from '../interfaces'

export const showModal = createAction<ModalType>('SHOW_MODAL')
export const hideModal = createAction('HIDE_MODAL')

export type ShowModal = typeof showModal
export type HideModal = typeof hideModal
